<script setup lang="ts">
import BreadCrumb from '#components/breadCrumb/BreadCrumb.vue';
import { useLanguage } from '#composables/useLanguage';
import { useUserStore } from '#stores/user.store';
import { computed } from 'vue';
import LanguageSelector from './LanguageSelector.vue';
import UserMenu from './UserMenu.vue';

const userStore = useUserStore();
const { setLanguage } = useLanguage();

const props = defineProps({
  showBreadCrumb: { type: Boolean, default: false, required: false }
});

const containerClasses = computed(() => ({
  'h-9 px-1 sm:gap-x-2 sm:px-2 lg:px-4': props.showBreadCrumb,
  'h-16 px-4 sm:gap-x-6 sm:px-6 lg:px-8': !props.showBreadCrumb
}));
</script>

<template>
  <div class="w-full">
    <div class="top-0 z-40 flex shrink-0 items-center gap-x-4" :class="containerClasses">
      <BreadCrumb v-if="showBreadCrumb" separator="|" :show-icon="true" />

      <div class="flex justify-end flex-1 gap-x-4 self-stretch lg:gap-x-6">
        <div class="flex items-center gap-x-4 lg:gap-x-6">
          <!-- Language selector -->
          <LanguageSelector @click="async (lang) => await setLanguage(lang)" />

          <!-- Separator -->
          <template v-if="userStore.authenticatedUser">
            <div class="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-900/10" aria-hidden="true" />

            <!-- Profile dropdown -->
            <UserMenu :user="userStore.authenticatedUser"
          /></template>
        </div>
      </div>
    </div>
  </div>
</template>
